import { map } from 'lodash'
import { RepositoryFactory } from 'src/api/repositories/RepositoryFactory'
import Vue from "vue";
const CourseRepository = RepositoryFactory.get('course');
const ProductsRepository = RepositoryFactory.get('products');

const PRODUCTS = {
    products: [],
    courses: [],
    bundles: [],
    subscriptions: [],
    blogPosts: [],
    promotions: [],
    productPricesForCoupon: {},
    productsLoaded: false,
    promotionsFetchedOnce : false,
    fetchingCourseContents : [], //holds ids of courses being fetched
}

export default {
    namespaced: true,
    state: PRODUCTS,
    // TODO refactor Repeated in admin
    getters: {
        paidCourses (store) {
            return store.courses.filter(course => course.access === 'public' && course.status == 'paid');
        },
        privateCourses (store) {
            return store.courses.filter(course => course.access === 'view-locked');
        },
        privateEnrollCourses (store) {
            return store.courses.filter(course => course.access === 'private-enroll');
        },
        comingSoonCourses (store) {
            return store.courses.filter(course => course.access === 'soon');
        },
        buyableCourses (store){
            return store.courses.filter(course => { return course.access === 'view-locked' ||  course.access === 'public' && course.status == 'paid' });
        },
        courseCategories (store) {
            return function (args) {
                let categories = [];

                store.courses.forEach((course) => {

                    if (course.tags && course.tags.length) {

                        course.tags.forEach( category => {
                            let existingCategoryIndex = categories.findIndex(categoryData => categoryData.category === category);

                            if (existingCategoryIndex> -1) {
                                categories[existingCategoryIndex].inCourse.push(course.titleId);
                            } else {
                                categories.push( {
                                    category,
                                    inCourse: [course.titleId]
                                })
                            }
                        })
                    }
                })

                return categories;
            }
        },
        freeCourses (store) {
            return store.courses.filter(course => course.access === 'public' && course.status == 'free');
        },
        courseAuthors (store) {
            return function (args) {
                let authors = [];

                store.courses.forEach((course) => {

                    if (course.authors && course.authors.length) {
                        if (args) {
                            return;
                        }

                        course.authors.forEach( authorData => {

                            let existingAuthorIndex = authors.findIndex(author => author.name === authorData.name);

                            if (existingAuthorIndex> -1) {
                                authors[existingAuthorIndex].inCourse.push(course.titleId);
                            } else {
                                authors.push( {
                                    ...authorData,
                                    inCourse: [course.titleId]
                                })
                            }
                        })
                    }
                })

                return authors;
            }
        },
        publicBundles(store){
            return store.bundles.filter(bundle => bundle.access === 'public');
        },
        publicSubscriptions(store){
            return store.subscriptions.filter(subscription => subscription.access === 'public');
        }
    },
    actions: {
        loadProducts ({ commit,dispatch, state , rootState }) {
            return ProductsRepository.getProducts().then((response) => {
                if (response.data.success) {
                    dispatch('setCourses',response.data.courses);
                    dispatch('setSubscriptions',response.data.subscriptions);
                    dispatch('setBundles',response.data.bundles);
                    //If it has legacy active Site Template make a new request to get the blog posts
                    if(rootState.siteTemplate.activeSiteTemplate){
                        dispatch('blog/setBlogPosts', response.data.blogPosts, {root: true});  
                    }else{
                        dispatch('blog/retrieveBlogPosts', response.data.blogPosts, {root: true});
                    }
                    
                }
            }, (err) => {
                console.log(err);
            });
        },
        getProductPromotions ({commit},payload) {
            return ProductsRepository.getProductPromotions(payload);
        },
        getStripeCoupons ({commit},payload) {
            return ProductsRepository.getStripeCoupons(payload);
        },
        setCourses ({ commit },payload) {
            commit("setCourses",payload);
        },
        setSubscriptions ({ commit },payload) {
            commit("setSubscriptions",payload);
        },
        setBundles({ commit },payload) {
            commit("setBundles",payload);
        },
        loadAllPromotions ({ commit }) {
            return ProductsRepository.getAllPromotions().then(response => {
                commit("loadAllPromotions",response);
                return response;
            })
        },
        loadProductPricesForCoupon( {commit} , payload) {
            return ProductsRepository.getProductPricesForCoupon(payload).then(response => {
                commit("loadProductPricesForCoupon" , { newPrices: response.data.products , couponCode: payload.couponCode});
                return response;
            })
        },
        setUserDataOnCourses({commit, state} , payload) {
            commit("setUserDataOnCourses",payload);
        },
        updateCourseData ({commit} , payload) {
            commit("updateCourseData" , payload)
        },
        registerUserToCourse ( {commit}, payload ) {
            return ProductsRepository.registerUserToCourse(payload).then(response => {
                if (response.data.success) {
                    commit('updateUseRegistrationStateInCourse', payload);
                }
                return response;
            });
        },
        getCourseContents ( { commit,state } , {courseId,getParams}) {
            state.fetchingCourseContents.push(courseId);

            return CourseRepository.getCourseContents({courseId,getParams}).then((response) => {
                state.fetchingCourseContents.splice(state.fetchingCourseContents.indexOf(courseId),1);
                if (response.data.success) {
                    commit('updateCourseData', response.data.course);
                    return response.data.course;
                }
            }, (err) => {
                console.log(err);
            });
        },
    },
    mutations: {
        setCourses (state , payload) {
            // console.log("setCourses with : " , payload)
            map(payload, (v, UID) =>  {
                //remove me from data of this verbosity because its incorrect
                delete v["me"];
                v["UID"] = UID;

                // console.log("now setting course: " , copyJson(v))
                const i = state.courses.findIndex(course => course.UID === v.id);

                if ( i > -1) {
                    // console.log("course is found , overwriting values")
                    map(v , (value,key) => {
                        // console.log("key : " , key , " overwritten with : " ,value)
                        Vue.set(state.courses[i],key,value);
                    })
                } else {
                    // console.log("course not found , appending course")
                    Vue.set(state.courses,state.courses.length,v);
                }
            });

            // console.log("final state :" , copyJson(state.courses))
        },
        setSubscriptions (state , subscriptions) {
            state.subscriptions = map(subscriptions, (v, UID) => ({ UID, ...v }));
        },
        setBundles (state , bundles ) {
            state.bundles = map(bundles, (v, UID) => ({ UID, ...v }));
        },
        loadAllPromotions (state , payload) {
            state.promotionsFetchedOnce = true;
            state.promotions = payload.data.promotions;
        },
        loadProductPricesForCoupon (state , {newPrices,couponCode}) {
            state.productPricesForCoupon[couponCode] = newPrices
        },
        setUserDataOnCourses (state,payload) {
            payload.forEach((userData) => {
                const i = state.courses.findIndex(course => course.UID === userData.courseId);

                if (i > -1) {
                    let editedCourse = state.courses[i];
                    editedCourse.me = userData.me;
                    // console.log("updating user data on course : " , state.courses[i].title , userData.me);
                    Vue.set(state.courses,i,editedCourse);
                }

            });

            // console.log("final state :" , copyJson(state.courses))
        },
        updateUseRegistrationStateInCourse (state, {courseId}) {
            state.courses.map((courseData,index) => {
                if (courseData.id === courseId) {
                    const clonedCourse = copyJson(courseData);
                    clonedCourse.me.registered = true;
                    Vue.set(state.courses, index, clonedCourse);
                }
            });
        },
        updateCourseData (state, course) {
            state.courses.map((courseData,index) => {
                if (courseData.id === course.id) {
                    let mergedData = courseData;

                    for (let key in course ) {
                        if (!course.hasOwnProperty(key)) {
                            continue;
                        }

                        mergedData[key] = course[key];
                    }

                    Vue.set(state.courses,index,mergedData);
                }
            })

        },
    },
}
